// extracted by mini-css-extract-plugin
export default {"box":"orderDetailPage_box__0CewG","box__order__detail":"orderDetailPage_box__order__detail__mY2hX"};